// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__+21qz","link-item":"footer_link-item__Uxp3A"};